import { FC } from "react";
import "./style.css";

interface Props {
  children: React.ReactElement | string;
  version?: "primary" | "secondary";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const Button: FC<Props> = ({
  children,
  onClick,
  disabled,
  className,
  version = "primary",
}) => {
  return (
    <button
      className={`${
        version === "primary" ? "primary-button" : "secondary-button"
      } ${className ? className : null}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
